import { Alert } from '../../types'

export const checkForCriticalAlerts = (props: any) => {
    const { alerts } = props;
    if(alerts) {
      return alerts.some((alert: Alert) => {
        return alert.critical === true;
      })
    } else return false;
    }


// WEBPACK FOOTER //
// ./src/utils/alerts/checkForCriticalAlerts.ts